export default __webpack_public_path__ + "static/media/frog_R2_C1.ab57b59f.png";